import { Skeleton } from '@app/components/various/Skeleton';
import { SkeletonLayout } from '@app/components/various/SkeletonLayout';
import { getIsAccountEditingEnabled, getIsSeller } from '@app/ducks';
import { useSelector } from 'react-redux';

export const CheckoutShippingAddressSkeleton = () => {
  const isSeller = useSelector(getIsSeller);
  const isAccountEditingEnabled = useSelector(getIsAccountEditingEnabled);
  const canAddAddress = isAccountEditingEnabled && isSeller;

  return (
    <div className="box">
      <div className="mb-5 flex items-center justify-between">
        <div className="basis-1/2">
          <Skeleton type="text" size="xlarge" />
        </div>
        <div className="basis-1/5">{canAddAddress && <Skeleton type="button" size="medium" />}</div>
      </div>
      <div className="grid gap-5 sm:grid-cols-2">
        <SkeletonLayout skeleton={<Skeleton type="rectangle" aspectRatio={1 / 3} />} repeatLayout={2} isLoading />
      </div>
    </div>
  );
};
